import { IconSvg, IconSvgProps } from "./icon"

export default function GoTo(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M20 13.23v5.54A1.23 1.23 0 0 1 18.77 20H5.23A1.23 1.23 0 0 1 4 18.77V5.23A1.23 1.23 0 0 1 5.23 4h5.54M15.692 4H20v4.308M20 4l-8 8" />
    </IconSvg>
  )
}
